<template>
	<v-card class='event-card elevation-0 d-flex flex-column'>
		<div class='event-card__container'>
			<div class='event-card__outer'>
				<div class='d-flex event-card__list pl-0 pr-0'>
					<div class='d-flex align-center justify-space-between mb-4'>
						<ButtonBack />
						<EventNavbar />
					</div>

					<div class='d-flex pb-5'>
						<v-skeleton-loader width='600' type='card' v-if='false'>
						</v-skeleton-loader>
						<FeaturedPost v-else />
					</div>

					<div class='pa-0 event-card__thumbnail-wrapper'>
						<div
							class="event-card__thumbnail-message-wrapper"
							v-if="event.event_sponsor_text"
							v-bind:style="{marginBottom: event.event_image ? '0' : '8px', borderRadius: event.event_image ? '10px 10px 0 0' : '10px'}"
						>
							<marquee>
								{{ event.event_sponsor_text }}
							</marquee>
						</div>
						<div style="position: relative;">
							<img
								v-if='!!event.event_image'
								class='event-card__thumbnail-image'
								:src='event.event_image'
								alt='event image'
								loading='lazy'
								v-bind:style="{borderRadius: event.event_sponsor_text ? '0 0 10px 10px' : '10px'}"
							/>

							<div
								v-if='this.event.pin_to_top'
								class='event-card__pin'
								:class="{'event-card__pin-square': event.event_sponsor_text && event.event_image}"
							>
								<span>
									<img :src='pinnedIcon' alt='iconPinned' class='mr-1' loading='lazy' />Pinned
								</span>
							</div>
						</div>
					</div>

					<div
						class='event-card__wrapper'
						v-bind:style="{paddingTop: event.event_image ? '25px' : '32px !important'}"
					>
						<v-card-text class='event-card__title pb-0'>
							{{ event.event_title }}
						</v-card-text>

						<v-card-text class='event-card__event-time pb-0 pt-5'>
							{{ event.dateTimePeriodToString }}
						</v-card-text>

						<v-card-text class='event-card__title pb-0 pt-5' v-if='event.address'>
							<div class='d-flex flex-column'>
								<div class='event-card__address'>{{ event.address.address_line1 }}</div>
								<div class='event-card__address'>{{ event.address.address_line2 }}</div>
								<div class='event-card__address'>
									{{ event.address.address_city }}&nbsp;{{ event.address.address_zip }}
								</div>
							</div>
						</v-card-text>

						<div v-if='this.event.event_register_link'>
							<div v-if='isExternal'>
								<a v-if='!isFollowed' :href='event.event_register_link' target='_blank'>
									<v-btn class='elevation-0 mt-5 event-card__register'> Register</v-btn>
								</a>
								<a v-else>
									<v-btn class='elevation-0 mt-5 event-card__registered' @click='onFollow'>
										Registered
									</v-btn>
								</a>
							</div>
							<div v-else>
								<a v-if='!isFollowed'>
									<v-btn
										class='elevation-0 mt-5 event-card__register'
										@click='onFollow'> Register
									</v-btn>
								</a>
								<a v-else>
									<v-btn class='elevation-0 mt-5 event-card__registered' @click='onFollow'>
										Registered
									</v-btn>
								</a>
							</div>
						</div>

						<div class='d-flex justify-center mt-4 px-5 font-weight-bold'>
							<div
								v-if='!isSchedule'
								class='event-card__schedule-btn'
								@click='onSchedule'
								style='cursor: pointer'
							>
								Add to Schedule
							</div>
							<div
								v-else
								class='event-card_schedule-btn'
								@click='onSchedule'
								style='cursor: pointer; color: #a0a0a0;'
							>
								Remove from Schedule
							</div>
						</div>

						<v-card-text class='event-card__subtitle pb-0 pt-5'> Details</v-card-text>

						<v-card-text class='event-card__subtitle-category pb-0 pt-3'>
							{{ event.category.category_name }}
						</v-card-text>


						<v-card-text class='event-card__description pb-0 pt-3 pb-4' v-html='this.description' />

						<v-card-subtitle
							v-if='this.event.tags.length !== 0 '
							class='event-card__meta-bottom d-flex align-center pa-0 mb-4'
						>
							<div>
								<v-chip
									:color='tag.tag_bg_color'
									:text-color='tag.tag_txt_color'
									class='post-preview-card__tag mr-2 mb-2 px-3 py-3'
									v-for='(tag, index) in this.event.tags'
									:key='index'
								>
									#{{ tag.tag }}
								</v-chip>
							</div>
						</v-card-subtitle>

						<div v-if='attendees.length > 0 && isAttendeesVisible'>
							<v-card-text class='event-card__subtitle py-5'>Attendees</v-card-text>

							<div class='d-flex flex-wrap'>
								<div v-for='(user, index) in attendees.slice(0,7)' :key='index' style='width: auto'>
									<Avatar
										class='mr-2 post-preview-card__avatar'
										size='60'
										:avatar='user.user_logo'
									/>
								</div>

								<div v-if='attendees.length > 8' class='event-card__attendees-last-container'>
									<Avatar
										class='mr-2 post-preview-card__avatar'
										size='60'
										:avatar='attendees[7].user_logo'
									/>
									<div class='event-card__attendees-last-member'>+{{ totalCountAttendees - 8 }}</div>
								</div>
							</div>

							<div class='d-flex justify-center mt-2'>
								<router-link
									:to="{ name: 'attendees-events', params: { id: this.event.event_id } }"
									class='text-decoration-none'
								>
									<div class='event-card__show-btn mt-3'>Show All</div>
								</router-link>
							</div>
						</div>

						<div v-if='this.event.eventActions && event.eventActions.length > 0'>

							<v-card-text class='event-card__subtitle pb-0 pt-5'>
								Event Actions
							</v-card-text>

							<div class='d-flex flex-wrap pb-2 pt-4'>
								<ActionPreview
									v-for='(action, index) in this.event.eventActions'
									:key='index'
									class='event-card__event-wrapper'
									:action='action'
								>
									<div class="event-card__action-wrapper" v-bind:style="{background: getAction(action).color}">
										<Icon
											:type='getAction(action).icon'
											color="white"
											:size='16'
										/>
									</div>
									<div class='event-card__event-title text-decoration-none'>
										{{ getAction(action).name }}
									</div>
								</ActionPreview>
							</div>
						</div>


						<div
							v-if='partners && partners.length > 0'
							v-for="({group_name = '', partners = [], group_id = 0 }, index) in this.event.partner_groups"
							:key='index'
						>
							<v-card-text class='event-card__subtitle pb-0 pt-5'>{{ group_name }}</v-card-text>

							<div class='event-card__exhibitors-container'>
								<div v-for='(partner, index) in partners.slice(0,6)'
									:key='index'
									class='event-card__exhibitors'
								>
									<router-link :to="{
										name: 'exhibitor-by-id',
										params: {
											id: partner.partner_id
										}
									}">
										<img :src='partner.partner_logo' alt='partner_logo' loading='lazy'>
									</router-link>
								</div>
							</div>

							<div class='d-flex justify-center'>
								<router-link
									:to="{ name: 'partner-events', params: { id: group_id, name: group_name } }"
									class='text-decoration-none'
								>
									<div class='event-card__show-btn mt-3'>Show All</div>
								</router-link>
							</div>
						</div>


						<div v-if='this.event.event_map'>
							<v-card-text class='event-card__subtitle my-4'>Event Map</v-card-text>
							<img
								:src='this.event.event_map'
								alt='event-map'
								style='width: 100%'
								loading='lazy'
							>
						</div>

						<div v-if="speakers.length">
							<v-card-text class='event-card__subtitle pb-0 pt-5 mb-4'>
								Speaker(s)
							</v-card-text>
							<EventSpeakerCard
								v-for="speaker in speakers"
								:key="speaker.speaker_id"
								:speaker="speaker"
							/>
							<router-link
								v-if="speakersShowAllButton"
								:to="{name: 'event-speakers', params: {id: this.event.event_id}}"
								class="d-flex justify-center"
							>
								<div class='event-card__show-btn mt-3'>Show All</div>
							</router-link>
						</div>

						<div v-if="polls.length">
							<v-card-text class='event-card__subtitle my-4'>Survey(s)</v-card-text>
							<Poll
								v-for="poll in polls"
								:key="poll.poll_id"
								:poll="poll"
								:answers="polls_answers"
								:isEventVoteDirty="isVoteDirty"
								:pollsLoading="pollsLoading"
								@answerChange="answerChange"
							/>
							<v-btn
								v-if="!isPollsVoted"
								class="event-card__poll-btn"
								:class="{'event-card__poll-btn-disabled': voteDisabled}"
								:ripple="false"
								@click="handleVote"
								:loading="pollsLoading"
							>
								Vote
							</v-btn>
						</div>

						<div v-if="ratings.length">
							<v-card-text class='event-card__subtitle my-4'>Rating(s)</v-card-text>
							<Rating
								v-for="rating in ratings"
								:key="rating.rating_id"
								:rating="rating"
								@ratingChange="ratingChange"
							/>
							<v-btn
								v-if="isRatingsAvailable"
								class="event-card__rating-btn"
								:class="{'event-card__rating-btn-disabled': ratingDisabled}"
								:ripple="false"
								@click="handleRate"
								:loading="ratingsLoading"
							>
								Send Rating
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import sponsoredStarIcon from '@/assets/images/icoт-sponsored-star.svg'
import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import { followEvent, unfollowEvent } from '@/api/event'
import ActionPreview from '@/components/Event/Action/ActionPreview'
import EventNavbar from '@/components/Event//EventNavbar.vue'
import ButtonBack from '@/components/ButtonBack'
import Poll from '@/components/Post/Poll'
import Rating from '@/components/Event/Rating'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard'

Vue.use(VueScrollTo)

export default {
	components: {
		ActionPreview,
		Avatar,
		FeaturedPost,
		EventNavbar,
		ButtonBack,
		Poll,
		EventSpeakerCard,
		Rating
	},
	props: {
		event: {
			type: Object,
			default: () => {
			}
		},
	},
	data() {
		return {
			offset: true,
			pinnedIcon,
			sponsoredStarIcon,
			description: this.event.event_description,
			isFollowed: 0,
			isSchedule: 0,
			polls_answers: [],
			isVoteDirty: false,
			rating_answers: []
		}
	},
	computed: {
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('event', ['attendees', 'totalCountAttendees', 'pollsLoading', 'ratingsLoading']),
		...mapGetters('settings', ['eventSettings']),

		isExternal() {
			return this.event.event_register_link.startsWith('http')
		},
		sponsorTextAnimationDuration() {
			if (this.event.event_sponsor_text) {
				const duration = this.event.event_sponsor_text.length / 20
				return duration < 5 ? 5 : duration
			} else {
				return null
			}
		},
		sponsorTextAnimation() {
			return this.event.event_sponsor_text.length <= 40 ? 'runningText1' : 'runningText2'
		},
		voteDisabled() {
			return this.pollsLoading || this.polls_answers.length !== this.polls.length || this.polls_answers.some(poll => poll.error)
		},
		polls() {
			return this.event.polls.filter(poll => poll.pollsAnswers.length || (!poll.pollsAnswers.length && poll.allow_custom_answer))
		},
		isPollsVoted() {
			return this.event.polls.every(poll => poll.vote)
		},
		isAttendeesVisible() {
			if (this.eventSettings) {
				return this.eventSettings.show_attendees
			}
			return false
		},
		speakers() {
			return this.event.speakersList
		},
		speakersShowAllButton() {
			return this.event.speakersList.length >= 5
		},
		ratings() {
			return this.event.ratings.filter(rating => !rating.vote || (rating.vote && rating.display_rating))
		},
		isRatingsAvailable() {
			return this.ratings.some(rating => !rating.vote)
		},
		availableRatings() {
			return this.ratings.filter(rating => !rating.vote)
		},
		ratingDisabled() {
			return this.rating_answers.length !== this.availableRatings.length
		}
	},
	methods: {
		...mapActions('post', ['getPost', 'deletePost']),
		...mapActions('event', ['addEventToSchedule', 'removeEventFromSchedule', 'voteEventPolls', 'voteEventRatings']),

		getAction(action) {
			let icons = {
				'link': 'link',
				'email': 'email',
				'phone': 'phone',
				'fileList': 'document',
				'linkList': 'list',
				'deepLink': 'link'
			}
			return {
				icon: icons[action.action_type],
				link: action.action_type !== '' && action.action_type !== '' ? action.action_value : null,
				name: action.action_name,
				color: action.button_color,
			}
		},

		onFollow() {
			if (this.isFollowed) {
				unfollowEvent(this.event.event_id)
			} else if (!this.isFollowed) {
				followEvent({ event_id: this.event.event_id })
			}

			this.isFollowed = !this.isFollowed
		},
		onSchedule() {
			if (this.isSchedule) {
				this.removeEventFromSchedule(this.event.event_id)
			} else if (!this.isSchedule) {
				this.addEventToSchedule({ event_id: this.event.event_id })
			}

			this.isSchedule = !this.isSchedule
		},
		answerChange(answer) {
			if (!answer.answer || (Array.isArray(answer.answer) && !answer.answer.length)) {
				if (this.polls_answers.length) {
					this.polls_answers = this.polls_answers.filter(poll => poll.poll_id !== answer.poll_id)
				}
			} else {
				const pollAnswer = this.polls_answers.find(poll => poll.poll_id === answer.poll_id)
				if (pollAnswer) {
					this.polls_answers = this.polls_answers.map(poll => {
						if (poll.poll_id === answer.poll_id) {
							return answer
						} else {
							return poll
						}
					})
				} else {
					this.polls_answers = [...this.polls_answers, answer]
				}
			}
		},
		async handleVote() {
			this.isVoteDirty = true
			if (!this.voteDisabled) {
				await this.voteEventPolls({ answers: this.polls_answers, eventId: this.event.event_id })
			}
		},
		ratingChange(rating) {
			if (this.rating_answers.find(item => item.rating_id === rating.rating_id)) {
				this.rating_answers = this.rating_answers.map(item => {
					if (item.rating_id === rating.rating_id) {
						return {
							...rating
						}
					} else {
						return item
					}
				})
			} else {
				this.rating_answers = [...this.rating_answers, rating]
			}
		},
		async handleRate() {
			if (!this.ratingDisabled) {
				await this.voteEventRatings({ ratings: this.rating_answers, eventId: this.event.event_id })
			}
		}
	},
	created() {
		// parse html text to  save spaces and rows
		const parser = new DOMParser()
		const doc = parser.parseFromString(this.event.event_description, 'text/html')
		this.description = doc.body.innerHTML

		if (this.event) {
			this.isFollowed = this.event.follow
			this.isSchedule = this.event.schedule
		}

	},
}
</script>

<style lang='scss'>
.v-card__text {
	padding: 0;
}

.event-card {
	background: #f1f1f1 !important;

	&__wrapper {
		background-color: white;
		border-radius: 13px;
		padding: 20px 25px;
	}

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		margin-bottom: 30px;
	}

	&__content-inner {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 18px;
		padding-top: 10px;

		img {
			width: 100%;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}

	&__meta {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: rgb(66, 160, 216);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: rgb(155, 155, 155);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			line-height: 16px;
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__list {
		position: relative;
		flex-direction: column;
	}

	&__title {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__event-time {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
	}

	&__attendees {
		&-member {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			object-fit: cover;
		}

		&-last-member {
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 999;
			background-color: rgba(0, 0, 0, 0.6);
			color: white;
			font-family: "Montserrat", sans-serif;
			font-size: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 3.7;

			width: 60px;
			height: 60px;
			border-radius: 50%;
		}

		&-last-container {
			position: relative !important;
			width: 60px !important;
		}

	}

	&__event {
		&-wrapper {
			display: flex;
			align-items: center;
			gap: 10px;
			width: 250px;
			margin-bottom: 20px;
			margin-right: 10px;

			i {
				border-radius: 50%;
				min-width: 40px;
				min-height: 40px;
			}
		}

		&-title {
			color: var(--ceil-detail-text-color);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
		}
	}

	&__exhibitors {

		&-container {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			padding: 10px 20px;
			gap: 15px 75px;
		}

		&-more {
			color: var(--accent-color);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			text-align: right;
		}

		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;

		img {
			width: 120px;
		}

	}

	&__subtitle {
		&-category {
			color: rgb(155, 155, 155);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		color: rgb(74, 74, 74);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__address {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
	}

	&__registered {
		color: rgb(255, 255, 255) !important;
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-align: center;
		background-color: #a0a0a0 !important;
		border-radius: 8px;
		height: 50px !important;
		width: 100%;
	}

	&__register {
		color: rgb(255, 255, 255) !important;
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-align: center;
		background-color: var(--button-secondary-background-color) !important;
		border-radius: 8px;
		height: 50px !important;
		width: 100%;
	}

	&__action-wrapper {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__description {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 22px;

		table {
			margin: 15px auto;
			border-collapse: collapse;
			font-family: Montserrat, sans-serif;
		}

		table td {
			padding: 15px;
			text-align: center;
		}

		table th {
			padding: 15px;
		}

		table thead td {
			background-color: #54585d;
			color: #ffffff;
			font-weight: bold;
			font-size: 13px;
			border: 1px solid #54585d;
			text-align: center;
		}

		table thead th {
			border: 1px solid #dddfe1;
		}

		table tbody td {
			color: #636363;
			border: 1px solid #dddfe1;
		}

		table tbody th {
			border: 1px solid #dddfe1;
		}

		table tbody tr {
			background-color: #f9fafb;
		}

		table tbody tr:nth-child(odd) {
			background-color: #ffffff;
		}

		img {
			width: 100%;
		}
	}


	&__thumbnail {

		&-wrapper {
			width: 100%;
			border-radius: 10px;
			position: relative;
			display: flex;
			flex-direction: column;
		}

		&-image {
			width: 100%;
			object-fit: cover;
		}

		&-message-wrapper {
			overflow: hidden;
			padding: 12px 6px 6px 6px;
			background: #fff;
			border-radius: 10px 10px 0 0;
		}
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		span {
			min-width: 100% !important;
			width: 100%;
		}
	}

	&__pin {
		position: absolute;
		top: 0;
		right: 0;
		text-align: right;

		span {
			z-index: 0;
			position: relative;
			background: var(--badge-pin-background);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			border-radius: 0 13px 0 0;
		}

		// Start
		span {
			&:before {
				z-index: -1;
				content: '';
				position: absolute;
				left: -8%;
				top: 0;
				height: 100%;
				width: 100%;
				background: var(--badge-pin-background);
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}

	&__schedule-btn, &__show-btn {
		color: var(--accent-color) !important;
		font-size: 16px;
		font-weight: 700;
		font-family: Montserrat, sans-serif;
		text-decoration: underline;
	}

	&__pin-square {
		span {
			border-radius: 0 !important;
		}
	}

	&__poll-btn, &__rating-btn {
		width: 100%;
        height: 50px !important;
        border-radius: 8px;
        font-size: 18px !important;
        line-height: 22px;
        font-weight: 700;
        text-transform: capitalize;
        background-color: var(--button-main-background-color) !important;
        color: var(--button-main-color) !important;

		&-disabled {
			opacity: 0.5;
            cursor: default;
		}
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			height: 100%;
			max-width: 100%;
			border-radius: 10px;

			&-image {
				max-height: 250px;
			}
		}
		&__default-thumbnail {
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

@keyframes runningText1 { // 0 - 40
	0% {
		transform: translateX(100%);
	}
	100% {
		transform: translateX(-50%);
	}
}
@keyframes runningText2 { // 50 - 180
	0% {
		transform: translateX(100%);
	}
	100% {
		transform: translateX(-100%);
	}
}

</style>
